<template>
  <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in"> -->
  <div class="layout">
    <v-flex xs5>
      <template v-if="value[intent_index].length > 0">
        <div
          style="display: flex; flex-direction: column; justify-content: center; margin: 20px 0px"
        >
          <draggable
            :list="answers[intent_index]"
            @end="onMoveCallback"
            :options="{ handle: '.handle', animation: 150 }"
          >
            <div
              v-for="(message, index) in value[intent_index]"
              :id="index"
              style="margin-bottom: 5px; width: 241px"
            >
              <chatbot-box
                :message="message"
                :keyIndex="index"
                :intent_index="intent_index"
                :answers="answers"
                :type="message.type"
                v-model="value[intent_index]"
                :broadcastType="broadcastType"
                @onSaveMessage="$emit('onSave')"
              >
              </chatbot-box>
            </div>
          </draggable>
        </div>
      </template>
      <template v-else>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 20px 0px;
          "
        >
          <img
            src="/static/img/assets/welcome/empty-chatboxMessage.svg"
            style="width: 80px; height: 80px; margin-bottom: 24px"
          />
          <typography h3 bold7 :label="$t('broadcast message no module')" :bold="true"></typography>
          <typography
            h6
            bold5
            :label="$t('broadcast message no module desc')"
            :medium="true"
          ></typography>
        </div>
      </template>
      <v-divider></v-divider>
      <div style="margin-top: 20px">
        <Typography style="margin-bottom: 10px;" slot="input" h5 semiBold color="color-darkBlue" :label="$t('broadcast message option')"/>
        <slot name="tags"></slot>
      </div>
    </v-flex>

    <v-flex xs5 class="preview-container">
      <preview-device-screen :answers="answers" :intent_index="intent_index" :choices="choice" />
    </v-flex>

    <v-flex xs2>
      <div
        :style="{
          fontWeight: 700,
          fontSize: '18px',
          color: broadcastType == 'draft' ? '#0c2f53' : '#0c2f5380',
        }"
      >
       {{$t("broadcast message add module")}} ({{ answers[intent_index].length }}/5)
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          gap: 20px;
          margin-top: 24px;
        "
      >
        <div v-for="(data, index) in this.addChat">
          <BoxAddChatbot
            :answers="answers"
            :data="data"
            :key="index"
            :intent_index="intent_index"
            v-model="value[intent_index]"
            :broadcast="broadcast"
            :broadcastType="broadcastType"
            @onSaveMessage="$emit('onSave')"
          ></BoxAddChatbot>
        </div>
      </div>
    </v-flex>
  </div>
  <!-- </transition> -->
</template>

<script>
import api from '@/api'
import config from '@/config' // config.serverUrl
import { mapGetters } from 'vuex'
import specialtext from '@/components/elements/specialtext'
import GenericViewer from '@/components/elements/GenericViewer'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewCartSummaryViewer2 from '@/components/elements/ViewCartSummaryViewer2'
import ImageType from './ImageType'
import Typography from '../../elements/Typography.vue'
import ChatbotBox from './ChatbotBox.vue'
import BoxAddChatbot from './BoxAddChatbot.vue'
import BoxAddNewAnswers from './BoxAddNewAnswers.vue'
import FacebookScreen from '@/components/elements/FacebookScreen'
import MessageViewer from '@/components/elements/MessageViewer'
import PreviewMessage from '@/components/elements/PreviewMessage'
import PreviewDeviceScreen from '@/components/elements/PreviewDeviceScreen'
import draggable from 'vuedraggable'

// import PaginationChatbot from './PaginationChatbot.vue'
export default {
  name: 'message-viewer',
  props: {
    value: [Object, String, Array],
    messages: {
      value: [Object, String, Array],
      default: () => [
        [
          {
            type: 'text',
            text: 'hello',
          },
        ],
      ],
    },
    background: {
      type: String,
      default: '#F1F0F0',
    },
    color: {
      type: String,
      default: 'black',
    },
    showDeep: {
      type: Boolean,
      default: true,
    },
    size: {
      default: 'small',
    },
    showProfile: {
      default: false,
      type: Boolean,
    },
    align: {
      default: 'left',
    },
    choice: {
      default: [],
    },
    questions: {
      default: [],
    },
    broadcast: {
      default: undefined,
    },
    broadcastType: {
      default: 'draft',
    },
    comment: {
      default: undefined,
    },
    isComment: {
      default: false,
    },
  },
  data: function () {
    return {
      showPreview: false,
      qustion_index: 0,
      isBottom: false,
      choices: [],
      group: this.value,
      intent_index: 0,
      showCopy: false,
      addChat: [
        {
          title: 'ข้อความ',
          image: '/static/img/assets/welcome/TypeAddText.svg',
          type: 'text',
        },
        {
          title: 'ปุ่มกด',
          image: '/static/img/assets/welcome/TypeAddButton.svg',
          type: 'button',
        },
        {
          title: 'รูปภาพ',
          image: '/static/img/assets/welcome/TypeAddImage.svg',
          type: 'image',
        },
        {
          title: 'วีดิโอ',
          image: '/static/img/assets/welcome/TypeAddVideo.svg',
          type: 'video',
        },
        {
          title: 'ลิสต์เมนู',
          image: '/static/img/assets/welcome/TypeAddListMenu.svg',
          type: 'generic',
        },
        {
          title: 'Flex Message',
          image: '/static/img/assets/welcome/TypeAddFlexMessage.svg',
          type: 'flex',
        },
        {
          title: 'Line Sticker',
          image: '/static/img/assets/welcome/TypeAddLineSticker.svg',
          type: 'sticker',
        },
      ],
    }
  },
  components: {
    specialtext,
    GenericViewer,
    IntentGetstarted,
    ViewCartSummaryViewer,
    ViewCartSummaryViewer2,
    ImageType,
    ChatbotBox,
    BoxAddChatbot,
    BoxAddNewAnswers,
    FacebookScreen,
    MessageViewer,
    PreviewMessage,
    Typography,
    PreviewDeviceScreen,
    draggable,
  },
  mounted: function () {
    var vm = this
    vm.choices = vm.choice
    if (vm.questions.length > 1) {
      setInterval(() => {
        if (vm.qustion_index === vm.questions.length - 1) {
          vm.qustion_index = 0
        } else {
          vm.qustion_index++
        }
      }, 5000)
    }
    vm.messages = vm.value
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage',
    }),
    answers: function () {
      var vm = this
      if (vm.group == null) {
        return []
      }
      var messagelist = []
      $.each(vm.value, function (index, group) {
        var newGroup = []
        $.each(group, function (mindex, message) {
          if (message[0]) {
            message = message[0]
          }
          if (
            (message.type === 'text' && message.text !== '') ||
            (message.type === 'button' &&
              message.buttons &&
              (message.buttons.length > 0 || message.text !== '')) ||
            (message.type === 'image' && message.image_url !== '' && message.image_url !== null) ||
            message.type === 'welcome_message' ||
            (message.type === 'flex' && message.contents !== '') ||
            (message.type === 'payment' && message.detail !== '') ||
            (['removeandaddtocart', 'addtocart', 'removetocart'].includes(message.type) &&
              message.detail !== '')
          ) {
            newGroup.push(message)
          } else if (message.type === 'generic') {
            var generics = []
            $.each(message.data, function (gindex, g) {
              if (
                g.title !== '' ||
                g.subtitle !== '' ||
                g.buttons.length > 0 ||
                (g.image_url !== '' && g.image_url != null) ||
                (typeof g.productid != 'undefined' && g.productid != null)
              ) {
                generics.push(g)
              }
            })
            if (generics.length > 0) {
              newGroup.push({
                type: 'generic',
                data: generics,
                ratio: message.ratio == 'horizontal' ? 'horizontal' : 'square',
              })
            }
          } else if (message.type === 'responsepost') {
            if (vm.showProfile) {
              if (
                message.replyinbox === true &&
                message.responseinbox[0].text !== '' &&
                message.responseinbox[0].text !== null
              ) {
                newGroup.push(message)
              }
            } else {
              if (
                (message.replyinbox === true &&
                  message.responseinbox[0].text !== '' &&
                  message.responseinbox[0].text !== null) ||
                (message.replycomment === true &&
                  message.responsecomment[0].text !== '' &&
                  message.responsecomment[0].text !== null) ||
                message.hidecomment === true
              ) {
                newGroup.push(message)
              }
            }
          } else if (['video', 'audio', 'imagemap', 'sticker', 'file'].includes(message.type)) {
            newGroup.push(message)
          }
        })
        if (newGroup.length > 0) {
          messagelist.push(newGroup)
        }
      })
      if (messagelist.length === 0) {
        messagelist = [[]]
      }
      vm.group = messagelist
      vm.genFlexMessage()

      return vm.group
    },
  },
  methods: {
    onMoveCallback(evt) {
      const indexBefore = evt.oldIndex // index ก่อนที่จะย้ายข้อมูลไปหลัง
      const indexAfter = evt.newIndex // index หลังที่จะย้ายข้อมูลไป
      if (indexBefore === indexAfter) {
        return
      }

      const removedNewAnswers = this.value[this.intent_index].splice(indexBefore, 1)[0]
      this.value[this.intent_index].splice(indexAfter, 0, removedNewAnswers)
      this.answers = this.value
      let vm = this
      vm.$store.dispatch('loading')
      vm.$emit('onSave')
      vm.$forceUpdate()
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.isBottom = true
      } else {
        this.isBottom = false
      }
    },
    
    changIntentIndex(index) {
      //Vue.set(this.intent_index, index)
      this.intent_index = index
      //  this.intent_index = index
      this.$forceUpdate()
    },
    genFlexMessage() {},
    linemessagecontenttypefile(messageid) {
      var vm = this
      let pdfWindow = window.open(
        `${config.serverUrl}linemessagecontenttypefile?pageid=${this.selectedBot.pageid}&messageid=${messageid}`
      )
    },
    goLinkBtn(link) {
      window.location.assign(link)
    },
    updateQueryString(uri, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
      var separator = uri.indexOf('?') != -1 ? '&' : '?'
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2')
      } else {
        return uri + separator + key + '=' + value
      }
    },
    onCopy: function () {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError: function () {},
    addNewAnswers: function () {
      let vm = this
      let data = {
        pageid: vm.$store.state.selectedBot.pageid,
        type: 'json',
      }
      vm.$store.dispatch('loading')
      const arr = [{}]
      this.value.push(arr)
      data['message'] = JSON.stringify(this.answers)
      //data['message'] = `[[{\"text\":\"one1\",\"type\":\"text\"},{\"text\":\"one2\",\"type\":\"text\"}],[{\"text\":\"two1\",\"type\":\"text\"},{\"text\":\"two2\",\"type\":\"text\"}],[]]`
      api.saveWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.cached_type = vm.type
        vm.cached_messages = JSON.stringify(messages)
        vm.bubbleMessages = messages
        vm.$store.dispatch('updateWelcomeMessage', {
          type: 'json',
          message: null,
          generics: null,
          messages: messages,
        })

        vm.isEditWelcome = false
        vm.$store.dispatch('loading')
      })
    },
    addNewAnswers2: function () {
      const arr = [
        { text: 'one10', type: 'text' },
        { text: 'one20', type: 'text' },
      ]
      this.answers.push(arr)
      //this.group.push(arr)
      this.$forceUpdate()
    },
  },
  watch: {
    value: function (newVal, oldVal) {
      // this.group = this.value
    },
  },
  filters: {
    splitimg: function (value) {
      return value.split(';;')
    },
  },
}
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
}
.box-layout {
  width: auto;
  /* border: 2px solid black; */
}
.box-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 6px;
}
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 270px;
  background-color: rgba(238, 238, 238, 1);

  color: rgba(12, 47, 83, 1);
  font-size: 12px;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  right: -250px;
  top: -50px;
  /* left: 100; */
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
.message {
  word-break: break-word;
}
.modal {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 30px 26px 30px 26px;
  position: fixed;
  top: 40px;
  overflow-x: hidden;
  border-radius: 10px;
}

.preview-container {
  background-color: #e6f0fb;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastAnswersMessage.vue